import { api } from '../api';

export const get = () => api.get(`/screening/survey`);

export const getById = (id: number) => api.get(`/screening/survey`, { params: { id } });

export const add = (body: any) => api.post(`/screening/survey`, { ...body });

export const addById = (id: number, body: any) => api.post(`/screening/survey?id=${id}`, { ...body });
